<div class="content primary-bg no-overflow" fxLayout>
  <img
    loading="lazy"
    alt="Decoration"
    class="decoration position-top-right on-primary-low tint-white"
    src="../../../assets/images/RC_Logo_Icon.svg"
  />
  <mat-card appearance="outlined" class="mat-elevation-z7">
    <router-outlet />
  </mat-card>
</div>
<recrewt-footer />
